import React, { createContext, useState, useContext, useMemo, useCallback } from 'react';
import { Webcast } from '@graphql/gql/graphql';

const WebcastStreamStatusContext = createContext<{
  updatedWebcastsBySession: undefined | Record<string, Webcast>;
  setUpdatedWebcastsBySession: (() => null) | ((prevWebcastsBySession: Webcast[]) => void);
  updateWebcastStreamStatus: undefined | ((webcast: Webcast) => (prevWebcastsBySession: Webcast[]) => void);
}>({
  updatedWebcastsBySession: undefined,
  setUpdatedWebcastsBySession: () => null,
  updateWebcastStreamStatus: undefined
});

export const useWebcastStreamStatusContext = () => useContext(WebcastStreamStatusContext);

export function WebcastStreamStatusProvider({ children }: { children?: React.ReactNode }): JSX.Element {
  const [updatedWebcastsBySession, setUpdatedWebcastsBySession] = useState([]);

  const updateWebcastStreamStatus = useCallback(webcast => {
    setUpdatedWebcastsBySession(prevWebcastsBySession => ({
      ...prevWebcastsBySession,
      [webcast?.sessionId]: webcast
    }));
  }, []);

  const value = useMemo(
    () => ({
      updatedWebcastsBySession,
      updateWebcastStreamStatus
    }),
    [updatedWebcastsBySession, updateWebcastStreamStatus]
  );

  return (
    // @ts-expect-error TS(2741) FIXME: Property 'setUpdatedWebcastsBySession' is missing ... Remove this comment to see the full error message
    <WebcastStreamStatusContext.Provider value={value}>{children}</WebcastStreamStatusContext.Provider>
  );
}

export default WebcastStreamStatusContext;
